import React from 'react';
import { IconProps } from '../icons/generated';
import { Banner as BannerNew, BannerProps as BannerNewProps, BannerStatus } from './Banner';

export type { BannerDirection, BannerSize, BannerStatus } from './Banner';
export type BannerKind = BannerStatus;

export interface BannerProps extends BannerNewProps {
  /** @deprecated status를 대신 사용해주세요. */
  kind?: BannerKind;
  /** @deprecated leftIcon을 대신 사용해주세요. */
  iconComponent?: React.ComponentType<IconProps>;
  /** @deprecated closable을 대신 사용해주세요. */
  closeButton?: boolean;
}

export const Banner = ({
  kind,
  iconComponent: IconComponent,
  closeButton,
  status,
  leftIcon,
  closable,
  ...props
}: BannerProps) => {
  return (
    <BannerNew
      {...props}
      status={status ?? kind}
      leftIcon={leftIcon ?? (IconComponent ? <IconComponent /> : undefined)}
      closable={closable ?? closeButton}
    />
  );
};
